import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";

import { companiesApi } from "@api/services";
import { ACTION_GET_CURRENT_COMPANY_INFO, roleGuard } from "@api";

export const ACTION_UPDATE_COMPANY_DEMODATA = "UPDATE_COMPANY_DEMODATA";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

interface UpdateCompanyRequest {
  companyId: string;
  status: boolean;
}

const updateCompanyDemoData = async (
  params: UpdateCompanyRequest,
): Promise<void> => {
  await companiesApi.companiesControllerUpdateCompanyDemoData(
    params.companyId,
    params.status,
  );
};

export const useUpdateCompanyDemoData = (
  user: UserProfileDto | null,
): {
  updateCompanyDemoData: (params: UpdateCompanyRequest) => void;
  updateCompanyDemoDataEnabled: boolean;
  isSuccessUpdateCompanyDemoData: boolean;
  isPendingUpdateCompanyDemoData: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_COMPANIES, ACTION_UPDATE_COMPANY_DEMODATA],
    mutationFn: enabled ? updateCompanyDemoData : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_COMPANIES, ACTION_GET_CURRENT_COMPANY_INFO],
      });
    },
  });

  return {
    updateCompanyDemoData: mutate,
    updateCompanyDemoDataEnabled: enabled,
    isSuccessUpdateCompanyDemoData: isSuccess,
    isPendingUpdateCompanyDemoData: isPending,
  };
};
